import { ChatCenteredTextIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const FChat = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ChatCenteredTextIcon {...rest} size={Sizes[size]} color={fill} />;
};

FChat.displayName = 'FChat';
